import FlexSpacer from "../../../shared/FlexSpacer";
import HorizontalSpacer from "../../../shared/HorizontalSpacer";

const LandingPageBlogCard = ({ summary, imageUrl, title, date, ...rest }) => {
  return (
    <div className="px-5 py-4 w-full lg:w-4/12 flex-grow " {...rest}>
      <div className="bg-white shadow-xl  h-full flex flex-col items-start">
        <img src={imageUrl} alt="" className="w-full" />

        <div className="flex-grow inline-flex flex-col   mt-2 p-7 ">
          <h2 className="font-extrabold text-xl">{title}</h2>

          <HorizontalSpacer amount="8" />

          <div>{summary}</div>

          <FlexSpacer />
          <div>{date}</div>
        </div>
      </div>
    </div>
  );
};

export default LandingPageBlogCard;
